import { I18n } from '@calendly/i18n';
import { BareButton } from '@calendly/ui/components/bare-button';
import { ArrowChevronLeftMiniIcon, ArrowChevronRightMiniIcon } from '@calendly/ui/components/icons';
import { BodyText } from '@calendly/ui/components/typography';
import classNames from 'classnames';
import { forwardRef } from 'react';
const buttonUseUpdatedStylesCss = "b1tdd2f4";
const buttonAlternateStylingCss = "b1fz84ku";
const buttonCss = "bpmpakf";
const Button = forwardRef((props, ref) => {
  const {
    useUpdatedStyles,
    alternateStyling,
    ...restProps
  } = props;
  return <BareButton ref={ref} {...restProps} className={classNames(buttonCss, {
    [buttonUseUpdatedStylesCss]: useUpdatedStyles,
    [buttonAlternateStylingCss]: alternateStyling
  }, props.className)} />;
});
const buttonContainerAlternateStylingCss = "bqkqr5w";
const buttonContainerCss = "b1wp993m";
const ButtonContainer = forwardRef((props, ref) => {
  const {
    alternateStyling,
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(buttonContainerCss, {
    [buttonContainerAlternateStylingCss]: alternateStyling
  }, props.className)} />;
});
const titleWrapperCss = "tz4ybn4";
const TitleWrapper = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(titleWrapperCss, props.className)} />;
});
const Navigation = ({
  isCurrentMonth,
  isLastMonth,
  setMonth,
  prevMonthId,
  nextMonthId,
  className,
  useUpdatedStyles,
  alternateStyling,
  title
}) => <ButtonContainer className={className} alternateStyling>
      <Button useUpdatedStyles={useUpdatedStyles} alternateStyling={alternateStyling} disabled={isCurrentMonth} aria-label={I18n.t('booking.templates.go_to_previous_month')} onClick={() => setMonth(prevMonthId)}>
        <ArrowChevronLeftMiniIcon size={(useUpdatedStyles || alternateStyling) && 'x-large'} />
      </Button>
      {alternateStyling && <TitleWrapper>
          <BodyText size="large" weight="bold">{title}</BodyText>
        </TitleWrapper>}
      <Button useUpdatedStyles={useUpdatedStyles} alternateStyling={alternateStyling} disabled={isLastMonth} aria-label={I18n.t('booking.templates.go_to_next_month')} onClick={() => setMonth(nextMonthId)}>
        <ArrowChevronRightMiniIcon size={(useUpdatedStyles || alternateStyling) && 'x-large'} />
      </Button>
    </ButtonContainer>;
export default Navigation;

require("./navigation.wyw-in-js.css!=!../../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./navigation.js");